import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IAddressInput } from "@/interfaces/contact.interface";
import contactService from "@/services/contact.service";
import { RequestsProps } from "@/types/requests.types";

export type CreateAdditionalAddressProps = {
  formData: IAddressInput;
} & RequestsProps;

export type UseCreateAdditionalAddressReturn = {
  create: (props: CreateAdditionalAddressProps) => Promise<void>;
} & UseLoadingReturn;

const useCreateAdditionalAddress = (): UseCreateAdditionalAddressReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<IAddressInput>({
    operation: (formData) => contactService.createAddress(formData),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useCreateAdditionalAddress;
